import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { Container, Heading } from '@grandvisionhq/elements';
import { useGetProductsBySkusExtended } from '@grandvisionhq/fun-search';
import { useIntl } from '@grandvisionhq/state';
import { withLazyLoading } from '@grandvisionhq/utils';
import { createImpressionEvent, createInteractionEvent } from '../../DataLayer/Events/ProductPromotionEvents.js';
import '@grandvisionhq/fun-products';
import { ProductListingGallery } from '../ProductListingGallery/ProductListingGallery.js';

const FeaturedProducts = ({ title , renderLocation , skus  })=>{
    const { getLabel , currency  } = useIntl();
    const { isLoading , listingProducts =[] , error  } = useGetProductsBySkusExtended({
        skus
    });
    const location = `featured reccommendation ${renderLocation}`;
    const handleImpression = React.useCallback((product, position)=>{
        DataLayer.pushEvent(createImpressionEvent(product, position, location, currency));
    }, [
        currency,
        location
    ]);
    const handleInteraction = React.useCallback((product, position)=>{
        DataLayer.pushEvent(createInteractionEvent(product, position, location, currency));
    }, [
        currency,
        location
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "featured-products",
        "data-t": "featured-products"
    }, /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(Heading, {
        className: "featured-products__title",
        variant: "medium",
        align: "center"
    }, title || getLabel('products.featured.title')), /*#__PURE__*/ React.createElement(ProductListingGallery, {
        skus: skus,
        products: listingProducts,
        isLoading: Boolean(isLoading),
        hasError: Boolean(error),
        onProductImpression: handleImpression,
        onProductInteraction: handleInteraction,
        shouldCenterSlideItems: true
    })));
};
var FeaturedProducts$1 = withLazyLoading(FeaturedProducts);

export { FeaturedProducts, FeaturedProducts$1 as default };
//# sourceMappingURL=FeaturedProducts.js.map
